import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { AppService } from 'src/app/core/services/app.service';
import { CustomerService } from 'src/app/core/services/customer.service';
import { SubscriptionItemService } from 'src/app/core/services/subscription-item.service';
import { AddressModel } from 'src/app/shared/models/address.model';
import { CustomerAddressDto } from 'src/app/shared/models/DTO/customer-dto';

@Component({
	selector: 'app-checkout-purchaser-info',
	templateUrl: './checkout-purchaser-info.component.html',
	styleUrls: ['./checkout-purchaser-info.component.scss'],
})
export class CheckoutPurchaserInfoComponent implements OnInit {
	@Output() formCompleteChange = new EventEmitter<boolean>();

	selectedAddress: CustomerAddressDto;

	constructor(public app: AppService, public subscriptionItemService: SubscriptionItemService, public customerService: CustomerService) {}

	ngOnInit(): void {}

	onAddressEntry(addressResponse: AddressModel) {
		this.subscriptionItemService.customer.street1 = addressResponse.street;
		this.subscriptionItemService.customer.city = addressResponse.city;
		this.subscriptionItemService.customer.state = addressResponse.state;
		this.subscriptionItemService.customer.postalCode = addressResponse.zipCode;
	}

	fieldEntry(field: string, value: string) {}

	submit() {
		this.formCompleteChange.emit(true);
	}
}
